import { Button, EmptyState, Icon, Icons, Intent, List, ListItem, Size } from "construct-ui";
import ViewBase from "../../views/view-base.view";
import languageModel from "../../models/language.model";
import surveyModel from "../../models/survey/survey.model";
import { exportUserExcelTemplate } from "../../models/file.model"
import { MIME_TYPES_AND_FILE_EXTENSION } from '../../config/constants';

export default function SiteResultViewComponent() {

  ViewBase.call(this);

  let _acceptableFileTypes = ['.xlsx'];
  let _isInValid = false;
  let _message = "";
  let fileFormData = null;
  let failedUploadedSiteIds = [];
  let existingList = [];
  let onChange = (e) => { };
  let uiListHeight = '300px';
  let selectedList = [];

  const downloadTemplate = () => {
    this.showLoading();
    const fileName = "Site Upload Template.xlsx";
    const exportConfig = {
      pageIndex: 0,
      pageSize: 100,
      storedProcedureCode: "20",
      params: [
        {
          code: "55",
          value: "ALTMP0002"
        }
      ],
      excelSheetNames: ["Site Codes"],
    };
    exportUserExcelTemplate(exportConfig, fileName)
      .catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  let _uploadExcelTemplate = () => {
    if (fileFormData != null) {
      _isInValid = false;
      _message = "";
      failedUploadedSiteIds = [];
      existingList = [];
      this.showLoading();
      surveyModel.checkUploadSites(
        (result) => {
          this.hideLoading();
          failedUploadedSiteIds = result.failedUpload;
          result.data.forEach(function (item) {
            let lgth = selectedList.filter(x => x.code === item.code);
            if (lgth == 0) {
              selectedList.push(item);
            } else {
              existingList.push(item);
            }
          });
          onChange(selectedList);
        },
        (error) => {
          this.hideLoading();
          this.handleError(error);
        },
        fileFormData
      );
    } else {
      _isInValid = true;
      _message = this.getText("EM00000316", "Please select a file")
    }
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onChange) {
        onChange = vnode.attrs.onChange;
      }
      if (vnode.attrs.selectedItemList) {
        selectedList = vnode.attrs.selectedItemList;
      }
    },
    onupdate: (vnode) => {
      if (vnode.attrs.selectedItemList) {
        selectedList = vnode.attrs.selectedItemList;
      }
    },
    view: (vnode) => {
      return [
        // Download template
        m('.card.mb-3',
          m('.card-body',
            m('.row.g-4.align-items-end',
              m('.col-md-7',
                m('label.form-label.d-block', '1. ', this.getText("LT00000218", "Download Template")),
                m(Button, {
                  class: 'ms-3',
                  iconLeft: Icons.DOWNLOAD,
                  intent: Intent.PRIMARY,
                  label: this.getText("LT00000220", "Excel Template"),
                  size: Size.SM,
                  onclick: () => { downloadTemplate() }
                })
              ),
              m('.col-md-7',
                m('label.form-label', '2. ', this.getText("LT00000197", "Excel Upload")),
                m('.d-flex.gap-2',
                  m('.flex-grow-1.ps-3',
                    m('input#file-upload.form-control[type=file][required]', {
                      onchange: (e) => {
                        let _fileTypeItem = MIME_TYPES_AND_FILE_EXTENSION.find(item => item.mimeType == e.target.files[0].type);

                        if (typeof _fileTypeItem !== 'undefined' && _acceptableFileTypes.indexOf(_fileTypeItem.extension) >= 0) {
                          fileFormData = new FormData();
                          fileFormData.append('file', e.target.files[0]);
                          _isInValid = false;
                          _message = "";
                        }
                        else {
                          _isInValid = true;
                          _message = this.getText("EM00000082", "Invalid file. Cannot process.");
                        }
                      }
                    }),
                  ),
                  m('.flex-shrink-0',
                    m(Button, {
                      label: this.getText("LT00000290", "Upload"),
                      intent: Intent.PRIMARY,
                      onclick: (e) => {
                        _uploadExcelTemplate();
                      }
                    }),
                  ),
                ),
              ),
              _isInValid && m('.col-md-12',
                m(
                  'div', { "class": "invalid-feedback fs-6", style: 'display:block;' },
                  m('small', _message)
                )
              )
            ),
          )
        ),
        // Upload result section & selected items section
        m('.row.g-4',
          m('.col-md-6',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: `min-height: ${uiListHeight}` },
                  m('.flex.flex-column', { style: { 'max-height': uiListHeight, 'overflow': 'auto' } },
                    (failedUploadedSiteIds?.length === 0 && existingList?.length === 0) ?
                      m(EmptyState, {
                        icon: Icons.UPLOAD,
                        content: languageModel.getText("LT00000712", "Please upload site list"),
                        fill: true,
                        style: 'color: #B5B5B5',
                      }) :
                      (failedUploadedSiteIds?.length > 0 &&
                        m('.position-sticky.top-0.bg-white.fw-bold.text-danger', this.getText("EM00000374", "Invalid Site Code(s)")),
                        m('ol',
                          failedUploadedSiteIds.map(id => m('li.ps-1', id))
                        ),
                        existingList?.length > 0 &&
                        m('.position-sticky.top-0.bg-white.fw-bold.text-danger', this.getText("LT00000548", "Already exists site Code(s)")),
                        m('ol',
                          existingList.map(item => m('li.ps-1', item.code + "-" + item.name))
                        )
                      )
                  ),
                )
              )
            ),
          ),
          m('.col-md-6',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: `min-height: ${uiListHeight}` },
                  selectedList && selectedList.length > 0
                    ? m(List, {
                      interactive: true,
                      style: {
                        height: uiListHeight
                      }
                    },
                      selectedList.map(item => m(ListItem, {
                        label: item.name,
                        contentRight: m(Icon, {
                          name: Icons.X,
                          intent: Intent.NEGATIVE,
                          onclick: e => {
                            let idx = selectedList.findIndex(s => s.code === item.code);
                            if (idx > -1) {
                              selectedList.splice(idx, 1);
                              onChange(selectedList);
                            }
                          }
                        })
                      }))
                    )
                    : m(EmptyState, {
                      icon: Icons.X_OCTAGON,
                      content: languageModel.getText("EM00000375", "No Sites selected"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    }),
                )
              )
            ),
            m('.d-flex.justify-content-end', m('span.mt-1', { style: 'font-size: 0.875em;' }, ((selectedList ? selectedList.length : '0') + ' ' + this.getText("LT00000364", "record(s)"))))
          )
        )
      ]
    }
  }
}